import { Component, Output, EventEmitter, OnInit, Input, ChangeDetectionStrategy, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppMediatorService } from '../../../services/app-mediator.service';
@Component({
    standalone: false,
    selector: 'por-busy-indicator',
    templateUrl: './busy-indicator-component.component.html',
    styleUrls: ['./busy-indicator-component.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BusyIndicatorComponentComponent implements OnInit {
    private readonly translateService = inject(TranslateService);
    private readonly appMediatorService = inject(AppMediatorService);

    @Output() readonly selectedTemplate: EventEmitter<string> = new EventEmitter<string>();
    @Input() message!: string;

    async ngOnInit() {
        const lang = this.appMediatorService.localStorageService.selectedContentLanguage;
        if (lang && lang !== this.translateService.getCurrentLang()) {
            this.translateService.use(lang);
        }
    }
}
